if (window.productInfoRowInitialized) {
  console.log('Product info row already initialized, skipping');
} else {
  window.productInfoRowInitialized = true;

  const MOBILE_BREAKPOINT = 751;
  let _infoRowAccordionUid = 0;
  const _infoRowCleanups = new WeakMap();

  function initProductInfoRowAccordion(container) {
    const labelContainer = container.querySelector('.product-info-row__label-container');
    const contentContainer = container.querySelector('.product-info-row__content');
    const chevron = container.querySelector('.chevron-down-icon');

    if (!labelContainer || !contentContainer) {
      return;
    }

    if (!contentContainer.id) {
      contentContainer.id = `product-info-row-panel-${_infoRowAccordionUid++}`;
    }

    const mq = window.matchMedia(`(max-width: ${MOBILE_BREAKPOINT - 1}px)`);

    const toggle = () => {
      const isOpen = contentContainer.dataset.infoRowOpen === 'true';
      const next = !isOpen;

      contentContainer.dataset.infoRowOpen = String(next);
      labelContainer.setAttribute('aria-expanded', String(next));

      if (chevron) {
        chevron.style.transform = next ? 'rotate(180deg)' : 'rotate(0deg)';
      }
    };

    const enableAccordion = () => {
      contentContainer.dataset.infoRowOpen = 'true';
      labelContainer.setAttribute('role', 'button');
      labelContainer.setAttribute('tabindex', '0');
      labelContainer.setAttribute('aria-expanded', 'true');
      labelContainer.setAttribute('aria-controls', contentContainer.id);
      if (chevron) chevron.style.transform = 'rotate(180deg)';
    };

    const disableAccordion = () => {
      delete contentContainer.dataset.infoRowOpen;
      labelContainer.removeAttribute('role');
      labelContainer.removeAttribute('tabindex');
      labelContainer.removeAttribute('aria-expanded');
      labelContainer.removeAttribute('aria-controls');
      if (chevron) chevron.style.transform = '';
    };

    labelContainer.addEventListener('click', () => {
      if (mq.matches) toggle();
    });

    labelContainer.addEventListener('keydown', (e) => {
      if (mq.matches && (e.key === 'Enter' || e.key === ' ')) {
        e.preventDefault();
        toggle();
      }
    });

    const syncState = () => {
      if (mq.matches) {
        enableAccordion();
      } else {
        disableAccordion();
      }
    };

    mq.addEventListener('change', syncState);
    syncState();

    _infoRowCleanups.set(container, () => mq.removeEventListener('change', syncState));
  }

  function initProductInfoRow(container) {
    initProductInfoRowAccordion(container);
  }

  setTimeout(() => {
    document.querySelectorAll('.product-info-row').forEach(initProductInfoRow);
  }, 500);

  document.addEventListener('shopify:section:load', (e) => {
    e.target.querySelectorAll('.product-info-row').forEach(initProductInfoRow);
  });

  document.addEventListener('shopify:section:unload', (e) => {
    e.target.querySelectorAll('.product-info-row').forEach((container) => {
      const cleanup = _infoRowCleanups.get(container);
      if (cleanup) {
        cleanup();
        _infoRowCleanups.delete(container);
      }
    });
  });
}
